module.exports = __webpack_public_path__ + "img/GAME_SEAOFFANTASY.37bb2f2f.jpg";